import React from "react";

/** Side-by-side column section for study add/edit modal */
export default function StudyFormSection({
  title,
  children,
  className = "",
}) {
  return (
    <section className={`study-modal-fold ${className}`.trim()}>
      <div className="study-modal-fold__head">
        <h6 className="study-modal-fold__title">{title}</h6>
      </div>
      <div className="study-modal-fold__body">{children}</div>
    </section>
  );
}
